// ログイン後・管理画面の GA4 ページビュー送信。
// head の gtag('config') は send_page_view: false にしてあるので、初回ロードと Turbo 遷移の両方で
// turbo:load ごとに 1 回だけ page_view を送る。LP は GTM が page_view を送るため meta が無く対象外。

// パスワード再設定等のトークンを GA4 に残さないため、page_location から除去するクエリ。
const SENSITIVE_QUERY_PARAMS = [
  "reset_password_token",
  "confirmation_token",
  "unlock_token",
  "invitation_token",
]

export function pageLocationWithoutTokens(href) {
  try {
    const url = new URL(href)
    SENSITIVE_QUERY_PARAMS.forEach((param) => url.searchParams.delete(param))
    return url.toString()
  } catch {
    return href
  }
}

document.addEventListener("turbo:load", () => {
  const meta = document.querySelector('meta[name="ga4-app-measurement-id"]')
  if (!meta || typeof window.gtag !== "function") return

  window.gtag("event", "page_view", {
    page_location: pageLocationWithoutTokens(window.location.href),
    page_title: document.title,
    send_to: meta.content,
  })
})
